import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractGoodReceiptList extends BaseModelAPI {

	static entity = 'newobject1954list'
	static entityName = 'subcontractgoodreceipt';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
